import { useHistoryTrackerState } from "../../../history";

export interface UserTriggeredModalsHistoryStateElement {
  id: string;
  args: unknown | null | undefined;
  state: unknown | null | undefined;
}

export interface RouteModalHistoryState {
  state: unknown | null | undefined;
}

export const userTriggeredModalStackHistoryKey = "MODALS_STATE";
export const routeModalStateHistoryKey = "ROUTE_MODAL";

export const useUserTriggeredModalsHistoryState = () => {
  return useHistoryTrackerState<UserTriggeredModalsHistoryStateElement[]>(userTriggeredModalStackHistoryKey, []);
};

export const useRouteModalHistoryState = () => {
  return useHistoryTrackerState<RouteModalHistoryState>(routeModalStateHistoryKey, { state: null });
};
